import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { RoomForm } from '../RoomForm';
import { RoomAction } from '../../../actions';

function AddRoom() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { formData, redirect } = useSelector(state => state.rooms);

  useEffect(() => {
    if (redirect.status) {
      history.push(redirect.url);
    }
  }, [redirect.status]);

  const updateFormData = (attribute, value) => {
    switch (attribute) {
      case 'name':
        dispatch(RoomAction.updateForm({ ...formData, name: value }));
        break;
      case 'alias':
        dispatch(RoomAction.updateForm({ ...formData, alias: value.split(',') }));
        break;
      default:
        dispatch(RoomAction.updateForm({ ...formData }));
        break;
    }
  };

  const formAction = () => {
    dispatch(RoomAction.create(formData));
  };

  return (
    <RoomForm
      formData={formData}
      updateFormData={updateFormData}
      onSubmit={formAction}
      formLabel="Create"
    />
  );
}

export { AddRoom };
